import { isSmallDevice } from "@/common/functions";
import LoginProfile from "@/components/LoginProfile/LoginProfile.vue";

export default {
    components: {
        LoginProfile,
    },
    data() {
        return {
            pageH1: this.$t("ccpaPageH1"),
            wflogo: {
                ariaLabel: this.$t("ccpaPageWfLogoAriaLabel"),
                alt: this.$t("ccpaPageWfLogoAltText"),
                title: this.$t("ccpaPageWfLogoTitleAttribute"),
                url: this.$t("ccpaPageWfLogoUrl")
            },
            ydlogo: {
                ariaLabel: this.$t("ccpaPageYdrLogoAriaLabel"),
                alt: this.$t("ccpaPageYdrLogoAltText"),
                title: this.$t("ccpaPageYdrLogoTitleAttribute"),
                url: this.$t("ccpaPageYdrLogoUrl")
            }
        };
    },
    methods: {
        isSmallDevice
    }
};



// WEBPACK FOOTER //
// ./src/components/CCPAHeader/CCPAHeader.js